// AUTO-GENERATED SQL Builder (V40 Final) for OfferingItem
import { 
  SqlField, 
  SqlExp, 
  SqlExpChain, 
  SqlFn, 
  SqlLiteral, 
  SqlSubQuery, 
  SqlApplyColumn, 
  SqlNavHybrid, 
  createNavHybrid 
} from '../utils/sql-core';
import { SqlAst } from '../utils/sql-ast';

export class OfferingItemSql {
  private ast = new SqlAst('OfferingItem', 'offeringItem');
  public readonly main: any = {};

  public guid: SqlField;
  public offeringId: SqlField;
  public name: SqlField;
  public mode: SqlField;
  public price: SqlField;
  public sortOrder: SqlField;
  public createdByUser: SqlNavHybrid;
  public offering: SqlNavHybrid;
  public updatedByUser: SqlNavHybrid;
  public bookingItemSelectionList: SqlNavHybrid;
  public itemPhotoList: SqlNavHybrid;
  public packageOptionList: SqlNavHybrid;
  public resaleList: SqlNavHybrid;
  public resaleTermList: SqlNavHybrid;
  public id: SqlField;
  public isDeleted: SqlField;
  public createdBy: SqlField;
  public createdDate: SqlField;
  public updatedBy: SqlField;
  public updatedDate: SqlField;

  constructor() {
    this.guid = new SqlField('offeringItem', 'guid', '', 'id', 'offeringItem_guid');
    this.offeringId = new SqlField('offeringItem', 'offeringId', 'offering', 'id', 'offeringItem_offering');
    this.name = new SqlField('offeringItem', 'name', '', 'id', 'offeringItem_name');
    this.mode = new SqlField('offeringItem', 'mode', '', 'id', 'offeringItem_mode');
    this.price = new SqlField('offeringItem', 'price', '', 'id', 'offeringItem_price');
    this.sortOrder = new SqlField('offeringItem', 'sortOrder', '', 'id', 'offeringItem_sortOrder');
    this.createdByUser = createNavHybrid('offeringItem', 'offeringItem_createdByUser', 'User');
    this.offering = createNavHybrid('offeringItem', 'offeringItem_offering', 'Offering');
    this.updatedByUser = createNavHybrid('offeringItem', 'offeringItem_updatedByUser', 'User');
    this.bookingItemSelectionList = createNavHybrid('offeringItem', 'offeringItem_bookingItemSelectionList', 'BookingItemSelection');
    this.itemPhotoList = createNavHybrid('offeringItem', 'offeringItem_itemPhotoList', 'ItemPhoto');
    this.packageOptionList = createNavHybrid('offeringItem', 'offeringItem_packageOptionList', 'PackageOption');
    this.resaleList = createNavHybrid('offeringItem', 'offeringItem_resaleList', 'Resale');
    this.resaleTermList = createNavHybrid('offeringItem', 'offeringItem_resaleTermList', 'ResaleTerm');
    this.id = new SqlField('offeringItem', 'id', '', 'id', 'offeringItem_id');
    this.isDeleted = new SqlField('offeringItem', 'isDeleted', '', 'id', 'offeringItem_isDeleted');
    this.createdBy = new SqlField('offeringItem', 'createdBy', '', 'id', 'offeringItem_createdBy');
    this.createdDate = new SqlField('offeringItem', 'createdDate', '', 'id', 'offeringItem_createdDate');
    this.updatedBy = new SqlField('offeringItem', 'updatedBy', '', 'id', 'offeringItem_updatedBy');
    this.updatedDate = new SqlField('offeringItem', 'updatedDate', '', 'id', 'offeringItem_updatedDate');

    for (const k of Object.keys(this)) {
      const v = (this as any)[k];
      if (v instanceof SqlField) this.main[k] = v;
    }
  }

  // SELECT
  select(fn:(x:OfferingItemSql)=>any) {
    this.ast.addSelectObject(fn(this));
    return this;
  }

  // WHERE
  where(fn:(x:OfferingItemSql)=>SqlExp | SqlExpChain) {
    this.ast.addWhere(fn(this));
    return this;
  }
  and(fn:(x:OfferingItemSql)=>SqlExp | SqlExpChain) {
    this.ast.addWhere(fn(this));
    return this;
  }
  or(fn:(x:OfferingItemSql)=>SqlExp | SqlExpChain) {
    this.ast.addOr(fn(this));
    return this;
  }

  // JOIN
  join(fn:(x:OfferingItemSql)=>SqlField | SqlNavHybrid) {
    const f = fn(this);
    this.ast.addJoin(f instanceof SqlNavHybrid ? f.asSqlField() : f);
    return this;
  }
  leftJoin(fn:(x:OfferingItemSql)=>SqlField | SqlNavHybrid) {
    const f = fn(this);
    this.ast.addJoin(f instanceof SqlNavHybrid ? f.asSqlField() : f, 'LEFT');
    return this;
  }
  rightJoin(fn:(x:OfferingItemSql)=>SqlField | SqlNavHybrid) {
    const f = fn(this);
    this.ast.addJoin(f instanceof SqlNavHybrid ? f.asSqlField() : f, 'RIGHT');
    return this;
  }

  // AND JOIN
  andJoin(fn:(l:any,r:any)=>SqlExp | SqlExpChain) {
    const last = this.ast.joins[this.ast.joins.length - 1];
    if (!last) throw new Error('andJoin() before join()');

    const left = new Proxy({}, {
      get:(_,prop:string)=> new SqlField(this.ast.alias, prop)
    });
    const right = new Proxy({}, {
      get:(_,prop:string)=> new SqlField(last.alias, prop)
    });

    const exp = (this.ast as any).compileExp(fn(left, right));

    if (typeof last.on === 'string') {
      last.on = {
        logic:'And', isTrusted:false,
        subFilters:[
          { column:last.on, operator:'', value:null, isTrusted:true, subFilters:[] },
          exp
        ]
      };
    }
    else if (last.on.logic === 'And') {
      last.on.subFilters.push(exp);
    }
    else {
      last.on = {
        logic:'And', isTrusted:false,
        subFilters:[ last.on, exp ]
      };
    }

    return this;
  }

  // CTE
  with(name:string, fn:(c:any)=>any) {
    this.ast.with(name, fn);
    return this;
  }
  withRecursive(name:string, fn:(c:any)=>any) {
    this.ast.withRecursive(name, fn);
    return this;
  }

  // CTE JOIN
  joinCTE(name:string, alias:string, fn:(l:any,r:any)=>SqlExp | SqlExpChain) {
    this.ast.joinCTE(name, alias, fn);
    return this;
  }
  fullJoinCTE(name:string, alias:string, fn:(l:any,r:any)=>SqlExp | SqlExpChain) {
    this.ast.fullJoinCTE(name, alias, fn);
    return this;
  }

  // SUBQUERY
  subQuery(fn:(b:any)=>any) {
    return new SqlSubQuery(fn);
  }

  // APPLY
  apply(name:string, fn:(b:any)=>any) {
    this.ast.apply(name, fn);
    return this;
  }
  applyColumn(name:string, fn:(b:any)=>SqlField) {
    return this.ast.applyColumn(name, fn);
  }
  crossApply(app:any) {
    this.ast.crossApply(app);
    return this;
  }

  // GROUP BY
  groupBy(fn:(x:OfferingItemSql)=>SqlField[]) {
    this.ast.addGroup(fn(this));
    return this;
  }

  // HAVING
  having(fn:(x:OfferingItemSql)=>SqlExp | SqlExpChain) {
    this.ast.addHaving(fn(this));
    return this;
  }

  // ORDER
  orderBy(fn:(x:OfferingItemSql)=>any[]) {
    this.ast.addOrder(fn(this));
    return this;
  }

  // UNION
  union(fn:(q:any)=>any) {
    this.ast.union(fn);
    return this;
  }
  unionAll(fn:(q:any)=>any) {
    this.ast.unionAll(fn);
    return this;
  }

  limit(n:number) { this.ast.take = n; return this; }
  offset(n:number) { this.ast.skip = n; return this; }

  build() {
    return this.ast.toQueryDescriptor();
  }
}
